// extracted by mini-css-extract-plugin
export default {"fieldsWrapper":"AssistantInformation_fieldsWrapper__wNrg-","detailsLinkList":"AssistantInformation_detailsLinkList__BTOG5","detailsLink":"AssistantInformation_detailsLink__YfCQL"};